import { storageKeys } from '@/shared/consts/storageKeys'
import { getFromLocalStorage, getFromSessionStorage } from './storageHelpers'

export const hasWebViewCookiesPermitted = () => {
  return getFromLocalStorage(storageKeys.webViewCookiesPermitted, false)
}

export const isWebView = () => {
  return Boolean(window.ReactNativeWebView)
}

export const hasWebViewCoordinates = () => {
  return Boolean(
    getFromSessionStorage(storageKeys.webViewGeolocationCoordinates, false)
  )
}

export const getWebViewGeolocationCoordinates = () => {
  if (!hasWebViewCoordinates()) {
    return null
  }

  const appLocationStorage = getFromSessionStorage(
    storageKeys.webViewGeolocationCoordinates,
    false
  )

  return appLocationStorage
    ? ({
        latitude: Number(appLocationStorage.latitude),
        longitude: Number(appLocationStorage.longitude)
      } as GeolocationPosition['coords'])
    : null
}
